export default __webpack_public_path__ + "static/piscina-vista-mar-add5e00ad28bca45fb27b4ffad027676.webp";